import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useDeleteSsoMembership = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.auth.deleteSsoMembership(input), useMutationOptions);
};
//# sourceMappingURL=useDeleteSsoMembership.js.map